import React from 'react';
import DSIconButton from './DSIconButton';
import { ReactComponent as PlusIcon } from './Icons/PlusIcon.svg';
import { useTheme } from '@mui/material';
import DSTooltip from './DSTooltip';

type DSPlusButtonProps = {
  onClick: (event: React.MouseEvent) => void;
  size: number;
  color: string;
  disabled?: boolean;
  title?: string;
};

const DSPlusButton = ({
  onClick,
  size,
  color,
  disabled,
  title = 'Add klydo to this unique feed',
}: DSPlusButtonProps) => {
  const { palette } = useTheme();
  return (
    <DSTooltip title={title}>
      <DSIconButton
        onClick={onClick}
        disabled={disabled}
        sx={{
          width: size,
          height: size,
          minWidth: size,
          minHeight: size,
          padding: 0,
          margin: 0,
          color: disabled ? palette.text.disabled : color,
          '&:hover': {
            background: 'transparent',
          },
        }}
      >
        <PlusIcon width={size} height={size} />
      </DSIconButton>
    </DSTooltip>
  );
};

export default DSPlusButton;
